<template>
  <div class="content">
    <div class="my">
      <div class="hometitle">
        <p class="title"><span></span>{{ title }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({ language: "getType" }),
    title() {
      return this.language == "中文"
        ? "鸟鸣识节变，草绿知春及"
        : " Orioles twitter of the transition of season, greening turfs know of the arrival of spring.";
    }
    // list() {
    //   return this.language == "中文"
    //     ? ["橙光", "诺信", "小佩", "52toys", "OASIS", "NewBanker"]
    //     : ["66RPG", "Naxions", "PETKIT", "52Toys", "OASIS", "NewBanker"];
    // },
    // more() {
    //   return this.language == "中文" ? "了解更多" : "Learn More";
    // }
  },
  methods: {
    scrollbar(value) {
      window.scrollTo({
        top: value,
        behavior: "smooth"
      });
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  padding-bottom: 45%;
  background: url("../assets/bg.png");
  background-size: 100% 100%;
  position: relative;
  .my {
    width: 1200px;
    position: absolute;
    top: 100px;
    left: 50%;
    margin-left: -630px;
  }
  .hometitle {
    width: 1200px;
    height: 260px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .title {
      font-size: 48px;
      font-family: PingFang SC;
      color: rgba(255, 255, 255, 1);
      text-shadow: 3px 4px 23px rgba(0, 158, 48, 0.34);
      margin: 0 10px;
      font-weight: 500;
      letter-spacing: 2px;
      span {
        display: inline-block;
        width: 62px;
        height: 103px;
        background: url("../assets/icon1.png");
        background-size: 100% 100%;
        vertical-align: middle;
      }
    }
    .text {
      display: inline-block;
      margin: 0 5px;
      font-size: 24px;
      color: rgba(255, 255, 255, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/content.vue